import LockIcon from '@mui/icons-material/Lock';
import MenuIcon from '@mui/icons-material/Menu';
import EmailIcon from '@mui/icons-material/Email';
import Person2Icon from '@mui/icons-material/Person2';
import DashboardIcon from '@mui/icons-material/Dashboard';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DeleteIcon from '@mui/icons-material/Delete';
import Groups2Icon from '@mui/icons-material/Groups2';
import EditIcon from '@mui/icons-material/Edit';
import menuImg from '../assets/menu.png';
import { Phone } from '@mui/icons-material';
import Lock from '@mui/icons-material/Lock';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import PlaceIcon from '@mui/icons-material/Place';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import InventoryIcon from '@mui/icons-material/Inventory';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import SettingsIcon from '@mui/icons-material/Settings';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DateRangeIcon from '@mui/icons-material/DateRange';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import QueueIcon from '@mui/icons-material/Queue';
import ConstructionIcon from '@mui/icons-material/Construction';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import PaymentIcon from '@mui/icons-material/Payment';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import TaskIcon from '@mui/icons-material/Task';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export const IMAGES = {
  logo: '',
};

export const ICONS = {
  notification: <NotificationsIcon sx={{ color: '#acd629' }} />,
  notificationOutline: <NotificationsOutlinedIcon sx={{ color: '#919EAB' }} />,
  email: <EmailIcon />,
  password: <LockIcon />,
  visible: <VisibilityIcon />,
  hide: <VisibilityOffIcon />,
  menu: <MenuIcon />,
  dashboard: <DashboardIcon />,
  user: <Person2Icon />,
  delete: <DeleteIcon />,
  edit: <EditIcon />,
  customer: <Groups2Icon />,
  phone: <Phone />,
  lock: <Lock />,
  city: <LocationCityIcon />,
  place: <PlaceIcon />,
  reference: <AssistantDirectionIcon />,
  order: <ShoppingCartIcon />,
  inventory: <InventoryIcon />,
  download: <FileDownloadIcon />,
  prepare: <HomeRepairServiceIcon />,
  settings: <SettingsIcon />,
  banks: <AccountBalanceIcon />,
  today: <TodayIcon sx={{ fontSize: 32 }} />,
  week: <DateRangeIcon sx={{ fontSize: 32 }} />,
  month: <CalendarMonthIcon sx={{ fontSize: 32 }} />,
  quarter: <DonutLargeIcon sx={{ fontSize: 32 }} />,
  year: <AllInclusiveIcon sx={{ fontSize: 32 }} />,
  inProgress: <RotateRightIcon sx={{ fontSize: 32 }} />,
  inQueue: <QueueIcon sx={{ fontSize: 32 }} />,
  preparing: <ConstructionIcon sx={{ fontSize: 32 }} />,
  awaiting: <HourglassTopIcon sx={{ fontSize: 32 }} />,
  dispatched: <LocalShippingIcon sx={{ fontSize: 32 }} />,
  readyForDispatched: <LocalShippingIcon />,
  readyDispatch: <DoneAllIcon sx={{ fontSize: 32 }} />,
  delivered: <WhereToVoteIcon sx={{ fontSize: 32 }} />,
  paymentRecieved: <PaymentIcon sx={{ fontSize: 32 }} />,
  pendingReview: <PendingActionsIcon sx={{ fontSize: 32 }} />,
  negotiationSuccess: <ThumbUpIcon sx={{ fontSize: 32 }} />,
  negotiationFail: <ThumbDownIcon sx={{ fontSize: 32 }} />,
  completed: <TaskIcon sx={{ fontSize: 32 }} />,
  whatsApp: (
    <WhatsAppIcon
      sx={{
        color: '#3fb652',
        fontSize: 44,
      }}
    />
  ),
  menuImg: <img src={menuImg} alt="Details" />,
};
